export default "__VITE_ASSET__B1n5rbF7__"